
import { useState, useEffect } from 'react';
import { NAV_LINKS } from '../constants';
import logo from '../images/logopic.png';
import { Link, useNavigate } from 'react-router';
const Header= () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  let nav=useNavigate();
  function f1()
  {
    nav("/kit1");
  }
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (    
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/90 backdrop-blur-md py-3 shadow-2xl' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between">
        <div className="flex flex-col">
          <img src={logo} style={{width:'100px'}} />
          {/*<span className="text-2xl font-bold tracking-tighter text-white leading-none">ARVIND</span>
          <span className="text-sm font-medium tracking-[0.2em] text-gold leading-none">MERA SATHI</span>*/}
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8">
          {NAV_LINKS.map((link) => (
            <Link 
              key={link.label} 
              to={link.href}
              className="text-sm uppercase tracking-widest font-medium hover:text-gold transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTAs */}
        <div className="hidden md:flex items-center space-x-4">
          <button onClick={f1}  className="px-6 py-2 border border-gold text-gold text-sm font-bold uppercase tracking-widest hover:bg-gold hover:text-black transition-all">
            Shop Now
          </button>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-white text-2xl"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10 p-8 flex flex-col space-y-6 animate-fadeIn">
          {NAV_LINKS.map((link) => (
            <a 
              key={link.label} 
              href={link.href}
              className="text-lg uppercase tracking-widest font-medium hover:text-gold"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <button onClick={f1} className="w-full py-4 border border-gold text-gold font-bold uppercase tracking-widest">
            Shop Now
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
